import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const PostBasicInfoComponent = ({
    selectedPost, handleInnerFormChange, topics,libraryData
}: any) => {


    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        

                         <InputContainer
                            label="Chapter Topic"
                            labelField="Subject"
                            list={topics}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ChapterTopicId'
                                )
                            }}
                            optionName='Choose Topic'
                            type="select"
                            value={selectedPost?.ChapterTopicId}
                            valueField="Id"
                        /> 

                        

                        <InputContainer
                            label="Text"
                            name="Text"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Text'
                                );
                            }}
                            type="text"
                            value={selectedPost?.Text}
                        />

                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />
        </>
    )
}

export default PostBasicInfoComponent;
